import { FallbackError } from '../organisms/FallbackError';

const NotFound = () => {
  return <FallbackError errorCode="404" errorText="Page inconnue" />;
};

export default NotFound;
export { NotFound };
